import { render } from "./VideosComponent.vue?vue&type=template&id=13279500&scoped=true"
import script from "./VideosComponent.vue?vue&type=script&lang=js"
export * from "./VideosComponent.vue?vue&type=script&lang=js"

import "./VideosComponent.vue?vue&type=style&index=0&id=13279500&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13279500"]])

export default __exports__